import { useEffect, useRef } from 'react';
import { analyticsAPI } from '../api';

// Session ID'yi sakla (sayfa yenilenene kadar aynı kalır)
let sessionId = null;

const getSessionId = () => {
  if (!sessionId) {
    sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  }
  return sessionId;
};

export const usePageTracking = (pageTitle = '') => {
  const trackedRef = useRef(false);

  useEffect(() => {
    // Sadece bir kez track et
    if (trackedRef.current) return;
    trackedRef.current = true;

    const trackPageView = async () => {
      try {
        await analyticsAPI.trackPageview({
          page_path: window.location.pathname,
          page_title: pageTitle || document.title,
          referrer: document.referrer || '',
          session_id: getSessionId(),
        });
      } catch (error) {
        console.error('Page tracking error:', error);
      }
    };

    // Admin panelinde tracking yapma
    if (!window.location.pathname.includes('/admin')) {
      trackPageView();
    }

    // Component unmount olduğunda ref'i sıfırla
    return () => {
      trackedRef.current = false;
    };
  }, [pageTitle]);
};

export const trackEvent = async (eventType, eventCategory, eventData = {}) => {
  try {
    await analyticsAPI.trackEvent({
      event_type: eventType,
      event_category: eventCategory,
      event_data: eventData,
      session_id: getSessionId(),
    });
  } catch (error) {
    console.error('Event tracking error:', error);
  }
};

export const trackAdminAction = async (actionType, resourceType, resourceId = '', details = {}) => {
  try {
    await analyticsAPI.trackAdminAction({
      action_type: actionType,
      resource_type: resourceType,
      resource_id: resourceId,
      details: details,
    });
  } catch (error) {
    console.error('Admin action tracking error:', error);
  }
};
